/**
 * Helpers URL CEE — fonctions pures sans dep API/storage (testables en node).
 *
 * Re-utilise par cee.js et ceeInbox.js pour eviter la duplication de chemins.
 *
 * IMPORTANT (Codex review S2.6 P2) : ces URLs sont utilisees dans <a download>
 * et dans <iframe src=...>. Elles N envoient PAS le header Authorization
 * Bearer. Track B doit donc cote backend exposer ces routes via :
 *   1) un mecanisme de signed URL court-lived (token URL parametre), OU
 *   2) cookie session HttpOnly + SameSite=Lax pour les routes /api/cee/...
 * Sinon, le download/preview retournera 401.
 *
 * Cette decision est documentee dans le plan d implementation S2 (Track B).
 * Le frontend peut s adapter quand le backend choisit son pattern : si signed
 * URL alors les helpers exposent une fonction async getDownloadUrl(id) qui fait
 * un fetch authentifie pour recuperer l URL signee, puis assigne.
 */

/**
 * URL de download d un document dossier.
 * @param {string} dossierId @param {string} docId @returns {string}
 */
export function downloadDocumentUrl(dossierId, docId) {
  return `/api/cee/dossiers/${dossierId}/documents/${docId}/download`;
}

/**
 * URL de preview d une PJ inbox (PDF inline).
 * @param {string} eventId @returns {string}
 */
export function inboxAttachmentPreviewUrl(eventId) {
  return `/api/cee/inbox/${eventId}/preview`;
}

/**
 * URL de telechargement du ZIP dossier complet (sprint A etape 15).
 * Le backend regroupe tous les is_current docs + un readme.txt.
 * @param {string|number} dossierId @returns {string}
 */
export function downloadDossierZipUrl(dossierId) {
  return `/api/cee/dossiers/${dossierId}/download-zip`;
}
